import { asyncRouterMap, constantRouterMap } from '@/router'

/**
 * 通过meta.code判断是否与当前用户权限匹配,无code的可以自由访问
 * @author 包红印
 * @time 2018-05-16 14:11:00
 */
export function hasPermission(menus, route) {
  if (route.meta && route.meta.code) {
    return menus.indexOf(route.meta.code) !== -1 ||
    route.children && route.children.length > 0 &&
    route.children.some(child => hasPermission(menus, child))
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户菜单的路由表
 * @param asyncRouterMap
 * @param menus
 * @author 包红印
 * @time 2018-05-16 14:08:00
 */
function filterAsyncRouter(asyncRouterMap, menus) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (hasPermission(menus, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, menus)
      }
      return true
    }
    return false
  })
  return accessedRouters
}
const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: []
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = []
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        const { menus } = data
        let accessedRouters
        if (menus.length === 0) {
          accessedRouters = [] // 如果菜单数据为空 赋值数组，此时只有constantRouterMap包含的路由
        } else {
          accessedRouters = filterAsyncRouter(asyncRouterMap, menus)
        }
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    }
  }
}

export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js